<template>
  <div id="hrms15e-detail3Info">
    <template v-if="detail3InfoDesc1Disp">
      <div class="detail detail-responsive">
        <div class="main-topic-box">
          <i class="left-arrow fa fa-angle-left" aria-hidden="true" v-show="!lov.grditem.loading" @click="triggerSetDetail3InfoSelected(-1)"></i>
          <div class="main-topic">{{ labels['HRAP31EC10']['40'] }} {{ detail3Info.rows[detailIndex].kpino }}</div>
          <i class="right-arrow fa fa-angle-right" aria-hidden="true" v-show="!lov.grditem.loading" @click="triggerSetDetail3InfoSelected(1)"></i>
        </div>
        <form class="form-horizontal">
          <div class="form-group margin-b-5">
            <label class="col-md-4 control-label">{{ labels['HRAP31EC6']['50'] }}</label>
            <div class="col-md-8">
              <div class="form-control readonly-field-color">{{ detail3Info.rows[detailIndex].kpino }}</div>
            </div>
          </div>
        </form>
        <form class="form-horizontal">
          <div class="form-group margin-b-5">
            <label class="col-md-4 control-label">{{ labels['HRAP31EC6']['60'] }}</label>
            <div class="col-md-8">
              <textarea  class="form-control readonly-field-color" readonly>{{ detail3Info.rows[detailIndex].kpiitem }}</textarea>
            </div>
          </div>
        </form>
        <form class="form-horizontal">
          <div class="form-group margin-b-5">
            <label class="col-md-4 control-label">{{ labels['HRAP31EC6']['70'] }}</label>
            <div class="col-md-8">
              <textarea  class="form-control"
                        v-model="detail3Info.rows[detailIndex].target"
                        :disabled="false || detail3Desc1Disp || detail3Desc2Disp"
                        maxlength="200"
                        id="detail3InfoTargetId"
                        v-validate="'max:200'"
                        data-vv-name="target"
                        :has-error="errors.has('target')"></textarea>
              <div class="text-error" v-show="errors.has('target')">{{errors.first('target')}}</div>
              <div class="remark-limit-character">{{ dispLimitLabel(200) }}</div>
            </div>
          </div>
        </form>
        <form class="form-horizontal">
          <div class="form-group margin-b-5">
            <label class="col-md-4 control-label">{{ labels['HRAP31EC6']['80'] }}</label>
            <div class="col-md-8">
              <textarea class="form-control"
                        v-model="detail3Info.rows[detailIndex].achieve"
                        :disabled="false || detail3Desc1Disp || detail3Desc2Disp"
                        maxlength="600"
                        v-validate="'max:600'"
                        data-vv-name="achieve"
                        :has-error="errors.has('achieve')"></textarea>
              <div class="text-error" v-show="errors.has('achieve')">{{errors.first('achieve')}}</div>
              <div class="remark-limit-character">{{ dispLimitLabel(600) }}</div> 
            </div>
          </div>
        </form>
        <form class="form-horizontal">
          <div class="form-group margin-b-5">
            <label class="col-md-4 control-label">{{ labels['HRAP31EC6']['90'] }}</label>
            <div class="col-md-8">
              <div class="form-control readonly-field-color">{{ detail3Info.rows[detailIndex].v_mtrunit }}</div>
            </div>
          </div>
        </form>
        <form class="form-horizontal">
          <div class="form-group margin-b-5">
            <label class="col-md-4 control-label">{{ labels['HRAP31EC6']['110'] }}</label>
            <div class="col-md-8">
              <div class="form-control readonly-field-color">{{ detail3Info.rows[detailIndex].mtrvalue }}</div>
            </div>
          </div>
        </form>
        <form class="form-horizontal">
          <div class="form-group margin-b-5">
            <label class="col-md-4 control-label">{{ labels['HRAP31EC6']['120'] }}</label>
            <div class="col-md-8">
              <div class="form-control readonly-field-color">{{ detail3Info.rows[detailIndex].v_mtrvalue }}</div>
            </div>
          </div>
        </form>
        <form class="form-horizontal">
          <div class="form-group margin-b-5">
            <label class="col-md-4 control-label">{{ labels['HRAP31EC6']['130'] }}</label>
            <div class="col-md-8">
              <hrms-dropdown  v-model="detail3Info.rows[detailIndex].status"
                              :options="dropdowns.statuskpi[nowLang]"
                              :disabled="false || detail3Desc1Disp || detail3Desc2Disp" />
                              <!-- v-validate="'required'"
                              data-vv-value-path="inputDate"
                              name="status"
                              :has-error="errors.has('status')" />
              <div class="text-error" v-show="errors.has('status')">{{errors.first('status')}}</div> -->
            </div>
          </div>
        </form>
        <form class="form-horizontal">
          <div class="form-group margin-b-5">
            <label class="col-md-4 control-label">{{ labels['HRAP31EC6']['150'] }}</label>
            <div class="col-md-8">
              <hrms-datepicker  v-model="detail3Info.rows[detailIndex].dtetargt"
                                v-validate="'date_format:DD/MM/YYYY'"
                                :disabled="false || detail3Desc1Disp || detail3Desc2Disp" />
            </div>
          </div>
        </form>
        <form class="form-horizontal">
          <div class="form-group margin-b-5">
            <label class="col-md-4 control-label">{{ labels['HRAP31EC6']['140'] }}</label>
            <div class="col-md-8">
              <div class="form-control readonly-field-color">{{ detail3Info.rows[detailIndex].kpiwgt }}</div>
            </div>
          </div>
        </form>
        <form class="form-horizontal">
          <div class="form-group margin-b-5">
            <label class="col-md-4 control-label">{{ labels['HRAP31EC6']['160'] }}</label>
            <div class="col-md-8" v-if="detail3Info.rows[detailIndex].kpino !== ''">
              <div class="row">
                <div class="col-md-8">
                            <!-- :params="searchParams()" -->
                  <hrms-lov v-model="detail3Info.rows[detailIndex].grdscor"
                            lovType="grditem"
                            :disabled="false || detail3Desc1Disp || detail3Desc2Disp"
                            :nowLang="nowLang"
                            @setDataRow="triggerLovSelect"
                            @fineDescLov="setQtyScore"
                            name="grdscor"
                            />
                </div>
                <div class="col-md-4">
                  <div class="form-control readonly-field-color">{{ getFormat(detail3Info.rows[detailIndex].qtyscor) }}</div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="form-group margin-b-5">
          <label class="col-md-12 ">{{ labels['HRAP31EC6']['190'] }}</label>

        </div>
        <hrms-table :columns="detail3InfoTable"
                    :data="{ total: detail3Info.rows[detailIndex].table.length, rows: detail3Info.rows[detailIndex].table }"
                    :addInlineEventBool="true && !detail3Desc1Disp && !detail3Desc2Disp && validateStaappr"
                    :editInlineEventBool="true && !detail3Desc1Disp && !detail3Desc2Disp"
                    :deleteInlineEventBool="true && !detail3Desc1Disp && !detail3Desc2Disp"
                    :deleteInlineBtnDisp="false"
                    :saveInlineEvent="callSave"
                    :saveInlineBtnDisp="false"
                    :indexDisp="false"
                    :searchDisp="false"
                    :columnEvent="columnEvent"
                    ref="detail3InfoTable"  />

        <div class="box-footer" v-show="!detail3Desc1Disp && !detail3Desc2Disp">
          <div class="col-md-6 clear-padding">
            <button type="button" class="btn bg-color-skin" @click="postDetail3Info()" v-if="validateStaappr"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
          </div>
          <div class="col-md-6 clear-padding">
            <div class="dropup" align="right">
              <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ labels['HRAP31EC3']['320'] }}
                <span class="caret"></span>
              </button>
              <ul class="dropdown-menu pull-right" aria-labelledby="dropdownMenu2">
                <li class="cursor-pointer"><a @click="courseRequired()">{{ labels['HRAP31EC6']['220'] }}</a></li>
                <li class="cursor-pointer"><a @click="detailWork()" data-toggle="modal" href="#hrms15e-popup3-desc2" >{{ labels['HRAP31EC6']['230'] }}</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else="detail3InfoDesc1CourseDisp">
      <detail3InfoDesc1 :labels="labels"
                        :searchIndex="searchIndex"
                        :indexSelected="indexSelected"
                        :detail="detailCourse"
                        :detail3InfoDesc1Table="detail3InfoDesc1Table"
                        :nowLang="nowLang"
                        :receivedHrms15eDetailCourseAddInline="receivedHrms15eDetailCourseAddInline"
                        :postDetailCourseSave="postDetailCourseSave"
                        :validateStaappr="validateStaappr" />
    </template>

    <popup  :labels="labels"
            :labelsButton="labelsButton"
            :nowLang="nowLang"
            :data="popupDetail3InfoDesc2"
            :detail3InfoDesc2PopupTable="detail3InfoDesc2PopupTable"
            :receivedHrms15eDetail3InfoDesc2Popup="receivedHrms15eDetail3InfoDesc2Popup" />

  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as lovTypes from 'store/modules/hrmsLov/mutation-types'
import detail3InfoDesc1 from 'components/hrms15e/detail3InfoDesc1'
import popup from 'components/hrms15e/popupDetail3InfoDesc2'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'
import { numberFormat } from 'assets/js/numberFormat.js'

export default {
  name: 'hrms15e-detail3Info',
  props: [
    'labels',
    'labelsButton',
    'nowLang',
    'dropdowns',
    'searchIndex',
    'indexSelected',
    'detail3Info',
    'detailCourse',
    'codcomp',
    'qtyscorcp',
    'qtyscor',
    'detail3InfoTable',
    'toggleBackToDetail3',
    'postDetail3InfoSave',
    'popupDetail3InfoDesc2',
    'detail3InfoDesc1Table',
    'detail3InfoDesc2PopupTable',
    'receivedHrms15eDetailCourse',
    'detail3InfoDesc1Disp',
    'inlineDetail3Info',
    'setInlineDetail3Info',
    'setDetail3InfoDesc1Disp',
    'setDetail3InfoDisp',
    'receivedHrms15eDetail3InfoDesc2Popup',
    'receivedHrms15eDetailCourseAddInline',
    'postDetailCourseSave',
    'detail3InfoSelected',
    'setDetail3InfoSelected',
    'setShowDetailDescDisp',
    'detail3Desc1Disp',
    'detail3Desc2Disp',
    'detail3InfoDesc1CourseDisp',
    'setDetail3InfoDesc1CourseDisp',
    'detail3InfoIndexSelected',
    'setDetail3InfoIndexSelected',
    'validateStaappr',
    'toggleTab3InfoBack',
    'detailAll',
    'calResultScore',
    'calTotalScore'
  ],
  data () {
    return {
      detailIndex: 0
    }
  },
  computed: {
    ...mapGetters({
      lov: lovTypes.GET_LOV
    })
  },
  watch: {
    detail3InfoIndexSelected () {
      this.detailIndex = this.detail3InfoIndexSelected
    }
  },
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    searchParams () {
      return {
        p_codempid: this.indexSelected.codempid,
        p_dteyreap: this.searchIndex.year,
        p_numtime: this.searchIndex.numtime,
        p_kpino: this.detail3Info.rows[this.detailIndex].kpino
      }
    },
    triggerLovSelect (lovGrdscorData) {
      this.detail3InfoSelected.qtyscor = lovGrdscorData.qtyscor * this.detail3InfoSelected.kpiwgt
    },
    columnEvent (eventName, param) {
      if (eventName === 'workno' || eventName === 'workitem' || eventName === 'actbedon') {
        param.kpino = this.detail3InfoSelected.kpino
      }
    },
    courseRequired () {
      let courseParams = {
        p_dteyreap: this.searchIndex.year,
        p_numtime: this.searchIndex.numtime,
        p_numseq: this.indexSelected.numseq,
        p_codempid_query: this.indexSelected.codempid
      }
      this.setShowDetailDescDisp(true)
      this.setDetail3InfoDisp(true)
      this.setDetail3InfoDesc1Disp(false)
      this.setDetail3InfoDesc1CourseDisp(true)
      this.receivedHrms15eDetailCourse(courseParams)
    },
    detailWork () {
      let popupParams = {
        p_dteyreap: this.searchIndex.year,
        p_numtime: this.searchIndex.numtime,
        p_numseq: this.indexSelected.numseq,
        p_kpino: this.detail3InfoSelected.kpino,
        p_codempid_query: this.indexSelected.codempid
      }
      window.scrollTo(0, 0)
      this.receivedHrms15eDetail3InfoDesc2Popup(popupParams)
    },
    triggerSetDetail3InfoSelected (index) {
      this.$refs.detail3InfoTable.$validator.validateAll()
        .then(result => {
          if (result) {
            this.detailIndex += index
            if (this.detailIndex < 0) {
              this.detailIndex = this.detail3Info.rows.length - 1
            }
            if (this.detailIndex > this.detail3Info.rows.length - 1) {
              this.detailIndex = 0
            }
            this.setDetail3InfoIndexSelected(this.detailIndex)
            this.setDetail3InfoSelected(this.detail3Info.rows[this.detailIndex])
            this.loadLovGrdItem(this.searchParams())
          }
        })
        .catch(error => {
          console.log(error)
          document.getElementsByName('workno0')[0].focus()
        })
    },
    loadLovGrdItem (params) {
      this.setLovGrdItem({ total: 0, rows: [], loading: false, finish: false })
      this.receivedLov({ lovType: 'GRDITEM', params: params })
    },
    getFormat (val) {
      return numberFormat(parseFloat(val))
    },
    setQtyScore (flg) {
      if (flg === 'notFound') {
        this.detail3InfoSelected.qtyscor = 0
      }
    },
    callSave (dataRowsHasFlg) {
      this.setInlineDetail3Info(dataRowsHasFlg)
    },
    postDetail3Info () {
      let _this = this
      this.$refs.detail3InfoTable.$validator.validateAll().then(result => {
        if (result) {
          swal({
            title: constLabels('confirmTitle'),
            text: constLabels('msgConfirmSave'),
            html: true,
            showCancelButton: true,
            closeOnConfirm: false,
            confirmButtonText: constLabels('ok'),
            cancelButtonText: constLabels('cancel')
          },
          function (isConfirm) {
            if (isConfirm) {
              _this.$validator.validateAll().then(result => {
                if (result) {
                  _this.setDetail3InfoDisp(false)
                  swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
                  _this.saveDetail3()
                }
              })
            }
          })
        }
      })
    },
    saveDetail3 (saveFromStatus) {
      let detail3InfoSelectedRows = []
      this.detail3Info.rows.map(dataMap => {
        detail3InfoSelectedRows.push({
          kpino: dataMap.kpino,
          kpiitem: dataMap.kpiitem,
          target: dataMap.target,
          achieve: dataMap.achieve,
          mtrunit: dataMap.mtrunit,
          mtrvalue: dataMap.mtrvalue,
          status: dataMap.status,
          dtetargt: dataMap.dtetargt,
          kpiwgt: dataMap.kpiwgt,
          grdscor: dataMap.grdscor,
          qtyscor: dataMap.qtyscor + '',
          table: dataMap.table.filter(dataFilter => {
            if (dataFilter.flgAdd && dataFilter.flgDelete) {
              return false
            } else {
              return dataFilter.flgAdd || dataFilter.flgDelete || dataFilter.flgEdit
            }
          }).map(dataMap => {
            return {
              actbedon: dataMap.actbedon,
              flg: dataMap.flgAdd ? 'add' : dataMap.flgDelete ? 'delete' : 'edit',
              kpino: dataMap.kpino,
              workitem: dataMap.workitem,
              workno: dataMap.workno
            }
          })
        })
      })
      let calQtyBeh
      let calQtyCmp
      if (saveFromStatus) {
        calQtyBeh = this.calResultScore(this.detailAll.tab1.table.rows) * 100 / this.calTotalScore(this.detailAll.tab1.table.rows)
        calQtyCmp = this.calResultScore(this.detailAll.tab2.table.rows) * 100 / this.calTotalScore(this.detailAll.tab2.table.rows)
      } else {
        calQtyBeh = this.indexSelected.qtybeh
        calQtyCmp = this.indexSelected.qtycmp
      }
      let detail3Info = {
        codempid_query: this.indexSelected.codempid,
        dteyreap: this.searchIndex.year,
        numtime: this.searchIndex.numtime,
        numseq: this.indexSelected.numseq,
        codcomp: this.codcomp,
        codpos: this.indexSelected.codpos,
        numlvl: this.indexSelected.numlvl,
        qtybeh: isNaN(calQtyBeh) ? '0' : calQtyBeh + '',
        qtycmp: isNaN(calQtyCmp) ? '0' : calQtyCmp + '',
        qtykpi: this.indexSelected.qtykpi,
        dteapman: this.indexSelected.dteapman,
        dteapstr: this.indexSelected.dteapstr,
        dteapend: this.indexSelected.dteapend,
        flgappr: this.indexSelected.flgappr,
        qtyscor: this.qtyscor,
        qtyscorcp: this.qtyscorcp,
        flgtypap: this.indexSelected.flgtypap,
        codaplvl: this.indexSelected.codaplvl,
        param_json: JSON.stringify(detail3InfoSelectedRows)
      }
      let detailParams = {
        p_dteyreap: this.searchIndex.year,
        p_numtime: this.searchIndex.numtime,
        p_codempid_query: this.indexSelected.codempid,
        p_codform: this.indexSelected.codform,
        p_numseq: this.indexSelected.numseq,
        p_codaplvl: this.indexSelected.codaplvl
      }
      this.postDetail3InfoSave({
        searchIndex: this.searchIndex,
        detail3Info: detail3Info,
        detailParams: detailParams,
        indexSelected: this.indexSelected,
        toggleTab3InfoBack: this.toggleTab3InfoBack
      })
    },
    focusError () {
      document.getElementByName('workno0').focus()
    },
    ...mapMutations({
      setLovGrdItem: lovTypes.SET_LOV_GRDITEM
    }),
    ...mapActions({
      receivedLov: lovTypes.RECEIVED_LOV
    })
  },
  components: {
    detail3InfoDesc1,
    popup
  }
}
</script>




// WEBPACK FOOTER //
// detail3Info.vue?2e8b0cbc